/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Camera } from '@appCanvasCommon/core/Camera';
import { utils } from 'pixi.js-legacy';

// If the focus level must be adjusted when a ticket is edited, this is the Z value used:
export const TICKET_EDIT_COMFORTABLE_ZOOM_LEVEL = 0.35;

//switching to object so it can be updated from values in firebase
export const LEVEL_OF_DETAIL_TABLE = {
	GTP_MAXIMUM: 6.0, // approximately 48 hours with a bit of buffer
	MAXIMUM: 0.6,
	VERY_HIGH: 0.4,
	COMFORTABLE: TICKET_EDIT_COMFORTABLE_ZOOM_LEVEL,
	MEDIUM: 0.2,
	LOW: 0.1,
	VERY_LOW: 0.01,
	ALWAYS: -Infinity,
	START: -100, // The starting value. Set very high on purpose.
};

//quick fix for this
export function updateLodTableFromRemote(lod: typeof LEVEL_OF_DETAIL_TABLE) {
	for (const key in LEVEL_OF_DETAIL_TABLE) {
		if (lod && lod[key]) {
			LEVEL_OF_DETAIL_TABLE[key] = lod[key];
		}
	}
}

// window.LevelOfDetaiLEnum = LEVEL_OF_DETAIL_TABLE;
export enum LEVEL_OF_DETAIL_TABLE_STRINGS {
	'MAXIMUM' = 'MAXIMUM',
	'VERY_HIGH' = 'VERY_HIGH',
	'COMFORTABLE' = 'COMFORTABLE',
	'MEDIUM' = 'MEDIUM',
	'LOW' = 'LOW',
	'VERY_LOW' = 'VERY_LOW',
	'ALWAYS' = 'ALWAYS',
	'START' = 'START', // The starting value. Set very high on purpose.
}

export enum LEVEL_OF_DETAIL_SIGNALS {
	'CHANGED' = 'changed',
	'FORCE_LOD' = 'forceLOD',
}
/**
 * Level of Detail singleton class that tracks the current detail level.
 */
export class LevelOfDetail {
	public static currentLOD = 'START';
	public static emitter: utils.EventEmitter = new utils.EventEmitter();
	public static isForced = false;
	private static _lastLod: string;

	public static getLOD(): string {
		return LevelOfDetail.currentLOD;
	}
	public static getLODLevel(): number {
		return LEVEL_OF_DETAIL_TABLE[LevelOfDetail.currentLOD];
	}
	public static getLastLOD(): string {
		return this._lastLod;
	}
	public static getLastLODLevel(): number {
		return LEVEL_OF_DETAIL_TABLE[LevelOfDetail._lastLod];
	}
	public static update(camera: Camera, force: boolean = false) {
		if (camera && camera.cameraContainer && !LevelOfDetail.isForced) {
			for (const level in LEVEL_OF_DETAIL_TABLE) {
				// let convertedNumber = parseFloat(level);
				const convertedNumber = LEVEL_OF_DETAIL_TABLE[level];
				if (!isNaN(convertedNumber)) {
					if (camera.cameraContainer.scale.x >= convertedNumber) {
						LevelOfDetail._lastLod = LevelOfDetail.currentLOD;
						LevelOfDetail.currentLOD = level;
						break;
					}
				}
			}
		}
		if (LevelOfDetail.getLODLevel() !== LevelOfDetail.getLastLODLevel() || force) {
			LevelOfDetail.emitter.emit(
				LEVEL_OF_DETAIL_SIGNALS.CHANGED,
				LevelOfDetail.getLODLevel(),
				LevelOfDetail.getLastLODLevel()
			);
		}
	}

	public static forceUpdate() {
		LevelOfDetail.emitter.emit(
			LEVEL_OF_DETAIL_SIGNALS.CHANGED,
			LevelOfDetail.getLODLevel(),
			LevelOfDetail.getLastLODLevel()
		);
	}

	/**
	 * Forces the Detail Level to the provided value
	 * @param {LEVEL_OF_DETAIL_TABLE} value
	 */
	public static forceLOD(value: LEVEL_OF_DETAIL_TABLE_STRINGS) {
		LevelOfDetail._lastLod = LevelOfDetail.currentLOD;
		LevelOfDetail.currentLOD = value;
		LevelOfDetail.forceUpdate();
		LevelOfDetail.emitter.emit(
			LEVEL_OF_DETAIL_SIGNALS.FORCE_LOD,
			LevelOfDetail.getLODLevel(),
			LevelOfDetail.getLastLODLevel()
		);
		LevelOfDetail.isForced = true;
	}

	public static clearForcedLOD(): void {
		LevelOfDetail.isForced = false;
	}

	public static reset() {
		LevelOfDetail.currentLOD = 'START';
	}
}
